export default __webpack_public_path__ + "static/media/LogoRunner.3cb57604.svg";